// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const ctaWrapper = "ChartHeader__ctaWrapper__4Bbnt";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const header = "ChartHeader__header__j6uJY";
export const hideOthers = "ChartHeader__hideOthers__Kf0h5";
export const item = "ChartHeader__item__7sLQP";
export const itemValue = "ChartHeader__itemValue__-HRlg";
export const itemsRow = "ChartHeader__itemsRow__HAwtz";
export const label = "ChartHeader__label__dP+cB";
export const labelsRow = "ChartHeader__labelsRow__Mgs05";
export const medium = "500";
export const member = "ChartHeader__member__uhs2C";
export const others = "ChartHeader__others__uP-Dv";
export const peers = "ChartHeader__peers__Z8c0s";
export const regular = "400";
export const sans = "'sans'";
export const secondaryLabelsWrapper = "ChartHeader__secondaryLabelsWrapper__VS0d4";
export const secondaryTitle = "ChartHeader__secondaryTitle__ZMqmH ChartHeader__titleBase__86uxW font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const secondaryValuesWrapper = "ChartHeader__secondaryValuesWrapper__FhpZu";
export const semibold = "600";
export const serif = "'serif'";
export const title = "ChartHeader__title__em4Gf ChartHeader__titleBase__86uxW font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const titleBase = "ChartHeader__titleBase__86uxW font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const twoRows = "ChartHeader__twoRows__UKwEB";